// extracted by mini-css-extract-plugin
export var aircallIframe = "_dj-3";
export var fabContainer = "_dj-5";
export var fabRinging = "_dj-6";
export var loadingOverlay = "_dj-4";
export var pulse = "_dj-7";
export var widgetContent = "_dj-2";
export var widgetPanel = "_dj-0";
export var widgetPanelExpanded = "_dj-1";